// @ts-nocheck — TODO(flow-migration): fix types incrementally
import { getRedirect, RULES } from '@clubmed/redirects';

import logger from 'Logger';
import config from 'Config';

import { PageNotFound } from 'Errors/errors';

import { patchAppContextUrl } from 'Server/context/patchAppContext';
import { createAppContextFromReq } from 'Server/context/createAppContextFromReq';

import { fetchDynamicPage } from 'Src/api/dynamic-page';
import { createRouterLocation } from 'Client/router/createRouterLocation';

import { DynamicPage } from 'Views/dynamic-page/DynamicPage';

export default DynamicPage;

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const { req, params, query, resolvedUrl } = ctx;

  const { originalUrl } = patchAppContextUrl(ctx);

  try {
    const appContext = { ...(await createAppContextFromReq(req)), originalUrl };

    const location = createRouterLocation({
      asPath: resolvedUrl,
      query,
      params,
      originalUrl,
    });

    const { pathname } = location;
    const hasCapitalLetter =
      // decodeURIComponent to handle non latin caracter (ex: /r/三亚/y is actually /r/%E4%B8%89%E4%BA%9A/y)
      decodeURIComponent(pathname) !== decodeURIComponent(pathname).toLowerCase();
    if (hasCapitalLetter) {
      throw new PageNotFound(); // this is needed because the CMS /live/search?pageUrl={page_url} API is not case-sensitive
    }

    const props = await fetchDynamicPage({ appContext, location });

    return {
      props,
    };
  } catch (err) {
    if (err instanceof PageNotFound && /^(?!\/?_?next\/data)/i.test(req.originalUrl)) {
      try {
        const { url, status } = await getRedirect(config.get(), req, [
          // Those rules only apply to b2c pages that couldn't be found in the CMS content b2c-pages
          RULES.NORMALIZE_B2C_SHOPPING_PATHS, // this redirection rule is temporary (i.e. issue #11090)
          RULES.B2C_CMS_CONTENT,
          RULES.PRODUCT_SHORT_LINKS,
          RULES.GLOBAL_B2C,
          RULES.LEGACY_B2C_NOT_FOUND,
        ]);

        if (url && url !== resolvedUrl) {
          return {
            redirect: {
              destination: url,
              permanent: status === 301,
            },
          };
        }
      } catch (_err) {
        if (_err !== undefined) {
          logger.error({ err: _err, info: { url: resolvedUrl } });
        }
      }
    }

    logger.error({ err, info: { url: resolvedUrl } });

    return {
      notFound: true,
    };
  }
};
